/* eslint-disable @typescript-eslint/ban-ts-comment */
import Client from './client';

const endpoint = '/authapi/v1/grant';

const refreshToken = (data: object) => {
    return Client.post(`${endpoint}/token/refresh`, data, {
        // @ts-ignore
        ignore401: true,
    });
};

const getToken = (data: object) => {
    return Client.post(`${endpoint}/token/ticket`, data, {
        // @ts-ignore
        ignore401: true,
    });
};

export default {
    refreshToken,
    getToken,
};
